import styled from "@emotion/styled";
import { Button, DatePicker, Typography } from "antd";
import { useState, useEffect } from "react";
import { useGetAentsList } from "hooks/useAgents";
import { useAppDispatch } from "store";
import { setLoading } from "store/slices/loadingSlice";
// import TableRequestDeleteList from "../TableRequestDeleteList";
import locale from "antd/es/date-picker/locale/th_TH";
import dayjs from "dayjs";
import TableRequestDeleteList from "./TableRequestDeleteList";

const { RangePicker } = DatePicker;

const RequestDeleteList = () => {
  // 2022-09
  const defaultMonth = dayjs().startOf("month");
  const startDate = dayjs(defaultMonth).startOf("month").toDate();
  const endDate = dayjs(defaultMonth).endOf("month").toDate();
  
  const [selectedMonth, setSelectedMonth] = useState<dayjs.Dayjs>(defaultMonth);

  const [dateRange, setDateRange] = useState<[Date, Date] | null>([
    startDate,
    endDate,
  ]);

  const dispatch = useAppDispatch();



  useEffect(() => {}, []);

  // useEffect(() => {
  //   if (isLoading) {
  //     dispatch(setLoading(true));
  //   } else {
  //     dispatch(setLoading(false));
  //   }
  // }, [isLoading]);

  return (
    <>
      <HeaderTabs>
        <LeftWrapper>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%" }}>
           <div style={{ flex: 1 }} >
           <Typography.Text
              style={{
                marginTop: 10,
                marginLeft: 10,
                fontWeight: 400,
                fontSize: 14,
                color: "#417B97",
              }}
            >
              รายการคำขอลบผู้ใช้ 
              {/* ({data?.contacts.length}) */}
            </Typography.Text>
           </div>

          </div>
        </LeftWrapper>
        <RightIconWrapper>
        </RightIconWrapper>
      </HeaderTabs>
      <TableRequestDeleteList />
      {/* data={data?.contacts} isLoading={isLoading} refetch={refetch} */}
    </>
  );
};

export default RequestDeleteList;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  flex-direction: row;
  width: 100%;
  border-bottom: 1px solid #e8e8e8;
  padding: 10px;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  width: 300px;
  flex: 1;
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
